/* Anemoia — mobile modal behaviour fixes for the quick-view dialog (#AnemoiaQuickview)
   and the wishlist drawer (#awl-drawer):
   1) they scroll internally and fit the viewport (quick view no longer opens mid-scroll);
   2) the page behind is scroll-locked while either is open (no background bleed on touch);
   3) the wishlist drawer spans the full viewport (top:0;bottom:0) so no dark gap shows below it;
   4) the wishlist drawer and the cart drawer are mutually exclusive — see PANEL EXCLUSIVITY.
   Self-contained: injects its own CSS, no dependencies. Lenis (desktop only) auto-pauses when we
   set overflow:hidden; on touch we also pin the body so iOS can't scroll behind. */
(function(){
  var CSS = [
    'dialog.anemoia-qv{max-height:92vh;max-height:92dvh;overflow:hidden;}',
    '.anemoia-qv .anemoia-qv__body{max-height:92vh;max-height:92dvh;overflow-y:auto;overscroll-behavior:contain;-webkit-overflow-scrolling:touch;}',
    '#awl-drawer{top:0!important;bottom:0!important;height:auto!important;}',
    '#awl-list{overscroll-behavior:contain;-webkit-overflow-scrolling:touch;}',
    '@media (max-width:749px){dialog.anemoia-qv{max-height:88vh;max-height:88dvh;width:calc(100% - 20px);}.anemoia-qv .anemoia-qv__body{max-height:88vh;max-height:88dvh;}}'
  ].join('');
  var st = document.createElement('style');
  st.id = 'anemoia-modal-fix-css';
  st.textContent = CSS;
  (document.head || document.documentElement).appendChild(st);

  var sy = 0, locks = 0, coarse = false;
  try { coarse = matchMedia('(pointer:coarse)').matches; } catch(e){}
  function lock(){
    if (locks++) return;
    sy = window.scrollY || document.documentElement.scrollTop || 0;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    if (coarse){
      document.body.style.position = 'fixed';
      document.body.style.top = (-sy) + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }
  }
  function unlock(){
    if (locks > 0) locks--;
    if (locks > 0) return;
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    if (coarse){
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, sy);
    }
  }

  /* ---- PANEL EXCLUSIVITY ----------------------------------------------------
     The wishlist drawer and the cart drawer were written independently and neither
     knew the other existed, so opening the heart while the cart was open (or vice
     versa) left both panels stacked on screen — and each one took its own scroll
     lock, so the page stayed locked until both were dismissed. Opening either panel
     now closes the other first.

     Each panel is closed through its OWN close path where one exists (cart-drawer
     exposes .close(); the wishlist has a close button), so their internal state
     stays in sync. Removing the class is only the last-resort fallback. */
  function cartEl(){ return document.querySelector('cart-drawer'); }
  function wishEl(){ return document.getElementById('awl-drawer'); }

  function cartIsOpen(){
    var c = cartEl();
    return !!(c && (c.classList.contains('active') || c.classList.contains('is-open')));
  }
  function wishIsOpen(){
    var w = wishEl();
    return !!(w && w.classList.contains('is-open'));
  }
  function closeCart(){
    var c = cartEl(); if (!c || !cartIsOpen()) return;
    try { if (typeof c.close === 'function') { c.close(); return; } } catch(e){}
    c.classList.remove('active', 'animate', 'is-open');
    document.body.classList.remove('overflow-hidden');
  }
  function closeWishlist(){
    var w = wishEl(); if (!w || !wishIsOpen()) return;
    var btn = w.querySelector('[data-awl-close], .awl-close, [aria-label="Close"], .awl-drawer__close');
    if (btn) { try { btn.click(); return; } catch(e){} }
    w.classList.remove('is-open');
  }

  function watchExclusivity(){
    var c = cartEl(), w = wishEl();
    if (c && !c.__amfExcl){
      c.__amfExcl = true;
      var cWas = cartIsOpen();
      new MutationObserver(function(){
        var o = cartIsOpen();
        if (o && !cWas){ cWas = true; closeWishlist(); }
        else if (!o && cWas){ cWas = false; }
      }).observe(c, { attributes:true, attributeFilter:['class'] });
    }
    if (w && !w.__amfExcl){
      w.__amfExcl = true;
      var wWas = wishIsOpen();
      new MutationObserver(function(){
        var o = wishIsOpen();
        if (o && !wWas){ wWas = true; closeCart(); }
        else if (!o && wWas){ wWas = false; }
      }).observe(w, { attributes:true, attributeFilter:['class'] });
    }
  }

  function watchQv(d){
    if (!d || d.__amf) return; d.__amf = true;
    function isOpen(){ return !!(d.open || d.hasAttribute('open')); }
    var was = isOpen();
    function onOpen(){ var b = d.querySelector('.anemoia-qv__body'); if (b){ b.setAttribute('data-lenis-prevent',''); b.scrollTop = 0; } lock(); }
    if (was) onOpen();
    new MutationObserver(function(){
      var o = isOpen();
      if (o && !was){ was = true; onOpen(); }
      else if (!o && was){ was = false; unlock(); }
    }).observe(d, { attributes:true, attributeFilter:['open'] });
    d.addEventListener('close', function(){ if (was){ was = false; unlock(); } });
  }
  function watchDrawer(d){
    if (!d || d.__amf) return; d.__amf = true;
    var was = d.classList.contains('is-open');
    if (was) lock();
    new MutationObserver(function(){
      var o = d.classList.contains('is-open');
      if (o && !was){ was = true; var l = document.getElementById('awl-list'); if (l) l.scrollTop = 0; lock(); }
      else if (!o && was){ was = false; unlock(); }
    }).observe(d, { attributes:true, attributeFilter:['class'] });
  }
  function scan(){
    watchQv(document.getElementById('AnemoiaQuickview'));
    watchDrawer(document.getElementById('awl-drawer'));
    watchExclusivity();
  }
  scan();
  if (window.MutationObserver){ new MutationObserver(scan).observe(document.body || document.documentElement, { childList:true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
})();
